import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    width: '100%',
    minHeight: 280,
    marginTop: theme.spacing(2),
    overflow: 'hidden',
    borderRadius: 12,
    boxShadow: '0 10px 28px rgba(15, 34, 52, 0.14)',
    color: theme.palette.common.white,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      minHeight: 0,
    },
  },
  media: {
    position: 'relative',
    minHeight: 280,
    backgroundColor: '#0A1F3D',
    [theme.breakpoints.down('sm')]: {
      minHeight: 180,
    },
  },
  photo: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  panel: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    backgroundColor: '#0A1F3D',
    padding: theme.spacing(4, 5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3),
    },
  },
  headline: {
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: 1.2,
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      fontSize: '26px',
    },
  },
  summary: {
    color: 'rgba(255, 255, 255, 0.92)',
    fontSize: '1rem',
    lineHeight: 1.5,
    marginBottom: theme.spacing(3),
  },
  cta: {
    marginRight: 72,
    cursor: 'pointer',
    '&.MuiButton-outlinedPrimary': {
      color: theme.palette.common.white,
      borderColor: 'rgba(255, 255, 255, 0.85)',
      boxShadow: 'none',
      fontWeight: 700,
      padding: '10px 24px',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.12)',
        color: theme.palette.common.white,
        borderColor: theme.palette.common.white,
      },
    },
  },
  logo: {
    position: 'absolute',
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    height: 48,
    width: 'auto',
    display: 'block',
    pointerEvents: 'none',
    [theme.breakpoints.down('sm')]: {
      height: 40,
      right: theme.spacing(1.5),
      bottom: theme.spacing(1.5),
    },
  },
}))

export default useStyles
